import { render, staticRenderFns } from "./add-zone-popup.vue?vue&type=template&id=774adb43"
import script from "./add-zone-popup.vue?vue&type=script&lang=js"
export * from "./add-zone-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports